import mapboxgl from 'mapbox-gl';
import bbox from '@turf/bbox';

import { createMap, renderSubways } from '../utils/map';

const NeighborhoodMapHook = {
  mounted() {
    const location = JSON.parse(this.el.dataset.center);
    const boundaryData = JSON.parse(this.el.dataset.boundary);

    const [lon, lat] = location['coordinates'];

    this.map = createMap(this.el, lon, lat, { zoom: 13, scrollZoom: false });

    this.map.on('load', () => {
      renderSubways(this.map);

      this.map.addSource('boundaries', {
        type: 'geojson',
        data: boundaryData,
      });

      this.map.addLayer({
        id: 'boundaries-line',
        source: 'boundaries',
        type: 'fill',
        paint: {
          'fill-color': '#165671',
          'fill-opacity': 0.2,
        },
      });

      this.map.addLayer({
        id: 'boundaries-fill',
        source: 'boundaries',
        type: 'line',
        paint: {
          'line-color': '#165671',
          'line-width': 2,
          'line-opacity': 0.7,
        },
      });

      this.map.fitBounds(bbox(boundaryData), { padding: 40 });
    });
  },
};

export default NeighborhoodMapHook;
